"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPagination = exports.usePaginationContext = exports.DEFAULT_METADATA = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var types_1 = require("../types");
var usePaginatedModel_1 = __importDefault(require("../hooks/usePaginatedModel"));
var luxon_1 = require("luxon");
var react_use_1 = require("react-use");
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var router_1 = require("next/router");
var pluralize_1 = __importDefault(require("pluralize"));
var Sentry = __importStar(require("@sentry/nextjs"));
var PaginatedInfiniteScroll_1 = __importDefault(require("../components/PaginatedInfiniteScroll"));
var lodash_1 = require("lodash");
var routes_1 = require("../util/routes");
var DEFAULT_PAGE_FILTERS = {
    page: 1,
    limit: 9,
    direction: types_1.PAGINATION_DIRECTION.ASC,
};
exports.DEFAULT_METADATA = {
    page: 1,
    count: 0,
    total_pages: 0,
    has_more: false,
    direction: types_1.PAGINATION_DIRECTION.ASC,
    uninitialized: true,
};
var FILTER_KEYS = [
    'after',
    'order_by',
    'direction',
    'limit',
    'page',
];
var PaginationContext = (0, react_2.createContext)({
    filters: DEFAULT_PAGE_FILTERS,
    metadata: exports.DEFAULT_METADATA,
    results: [],
    setFilters: function () { return null; },
    setPage: function () { return null; },
    nextPage: function () { return null; },
    prevPage: function () { return null; },
    setAfter: function () { return null; },
    getAfter: function () { return null; },
    getBefore: function () { return null; },
    getById: function (id) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, id];
    }); }); },
    componentProps: null,
    // mutateResults: async () => ({} as any as PaginationResponse),
    loading: false,
    removeItem: function () { return null; },
    scrollOffset: -150,
    isPreviousData: false,
});
var usePaginationContext = function () {
    return (0, react_2.useContext)(PaginationContext);
};
exports.usePaginationContext = usePaginationContext;
/**
 * withPagination is a HOC used to wrap a component with a PaginationContext giving it and it's child components
 * access to generic methods to interact with paginated models.
 * @param Component Component to be wrapped
 * @param options Default pagination options
 * @returns
 */
var withPagination = function (Component, 
// If the path is not dynamic, it can be set when calling the function
_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.infiniteScroll, defaultInfiniteScroll = _b === void 0 ? false : _b, _c = _a.scrollOffset, defaultScrollOffset = _c === void 0 ? -150 : _c, options = __rest(_a, 
    // If the path is not dynamic, it can be set when calling the function
    ["infiniteScroll", "scrollOffset"]);
    return function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var _q = _a.maintainPageQueryParams, maintainPageQueryParams = _q === void 0 ? true : _q, props = __rest(_a, ["maintainPageQueryParams"]);
        var query = (0, routes_1.useQuery)();
        var isInitialized = (0, react_1.useRef)(false);
        var _r = (0, react_2.useState)(defaultInfiniteScroll), infiniteScroll = _r[0], setInfiniteScroll = _r[1];
        var _s = (0, react_2.useState)(props.infiniteScrollProps), infiniteScrollProps = _s[0], setInfiniteScrollProps = _s[1];
        var _t = (0, react_2.useState)(defaultScrollOffset), scrollOffset = _t[0], setScrollOffset = _t[1];
        var _u = (0, react_2.useState)(__assign(__assign(__assign(__assign(__assign({}, DEFAULT_PAGE_FILTERS), options.defaultFilters), props.filters), (query.get('page')
            ? { page: +query.get('page') }
            : {
                page: (_e = (_c = (_b = props.filters) === null || _b === void 0 ? void 0 : _b.page) !== null && _c !== void 0 ? _c : (_d = options.defaultFilters) === null || _d === void 0 ? void 0 : _d.page) !== null && _e !== void 0 ? _e : DEFAULT_PAGE_FILTERS.page,
            })), { direction: (_j = (_g = (_f = props.filters) === null || _f === void 0 ? void 0 : _f.direction) !== null && _g !== void 0 ? _g : (_h = options.defaultFilters) === null || _h === void 0 ? void 0 : _h.direction) !== null && _j !== void 0 ? _j : DEFAULT_PAGE_FILTERS.direction })), filters = _u[0], setFilters = _u[1];
        // Custom properties passed to the implementing component
        var _v = (0, react_2.useState)(props.componentProps), componentProps = _v[0], setComponentProps = _v[1];
        // Array of paginated results from response
        var _w = (0, react_2.useState)([]), results = _w[0], setResults = _w[1];
        // Pagination metadata from response
        var _x = (0, react_2.useState)(exports.DEFAULT_METADATA), metadata = _x[0], setMetadata = _x[1];
        var router = (0, router_1.useRouter)();
        var path = options.defaultPath || props.path;
        var queryOptions = props.usePaginatedModelOptions;
        // Retrieve paginated results from the API based on the path and filters
        var _y = (0, usePaginatedModel_1.default)(path, filters, queryOptions), _z = _y.data, _0 = _z === void 0 ? {} : _z, apiMetadata = _0.metadata, _1 = _0.results, apiResults = _1 === void 0 ? [] : _1, 
        // mutate: mutateResults,
        isPreviousData = _y.isPreviousData, loading = _y.isFetching, fetcher = _y.fetcher, getModelById = _y.getModelById;
        /* Page based filtering methods */
        // Sort the results based on the pagination direction
        var sortResults = (0, react_1.useCallback)(function (results) {
            /**
             * When ordering by a nested property, the name of the nested property might not match
             * the name of the order by filter as one might be plural and the other might not be.
             * (i.e. order_by=group_users.created_at where as the property on the result is group_user.created_at)
             * @param m1
             * @param orderBy
             * @returns
             */
            var getOrderByColumn = function (m1, orderBy) {
                if (orderBy && (0, lodash_1.get)(m1, orderBy))
                    return orderBy;
                if (orderBy && orderBy.split('.').length > 1) {
                    var _a = orderBy.split('.'), parentProp = _a[0], rest = _a.slice(1);
                    var singular = __spreadArray([pluralize_1.default.singular(parentProp)], rest, true).join('.');
                    var plural = __spreadArray([pluralize_1.default.plural(parentProp)], rest, true).join('.');
                    var isSingular = (0, lodash_1.get)(m1, singular) != null;
                    if (!singular && !plural) {
                        Sentry.captureException(new Error("Invalid order by params: ".concat(orderBy)));
                        return 'created_at';
                    }
                    return isSingular ? singular : plural;
                }
                return 'created_at';
            };
            if (!results.length)
                return results;
            var orderBy = getOrderByColumn(results[0], filters.order_by);
            return results
                .filter(function (mi) { return mi; })
                .filter(function (modelInstance, index) {
                return results.findIndex(function (mi) { return mi.id === modelInstance.id; }) === index;
            })
                .sort(function (m1, m2) {
                return luxon_1.DateTime.fromISO((0, lodash_1.get)(m1, orderBy)) >
                    luxon_1.DateTime.fromISO((0, lodash_1.get)(m2, orderBy))
                    ? types_1.PAGINATION_DIRECTION.DESC === filters.direction
                        ? -1
                        : 0
                    : types_1.PAGINATION_DIRECTION.DESC === filters.direction
                        ? 0
                        : -1;
            });
        }, [filters.direction, filters.order_by]);
        var setPageQueryParams = (0, react_1.useCallback)(function (page) {
            if (!maintainPageQueryParams)
                return;
            if (router.query.page === page.toString() ||
                (page == 1 && !router.query.page))
                return;
            delete router.query.page;
            router.replace({
                pathname: router.pathname,
                query: __assign(__assign({}, router.query), (page == 1 ? {} : { page: page })),
            }, undefined, { shallow: true });
        }, [router, maintainPageQueryParams]);
        // Set the page to be retrieved
        var setPage = (0, react_1.useCallback)(function (page) {
            setFilters(function (params) { return (__assign(__assign({}, params), { page: page })); });
            // Update query parameters
            setPageQueryParams(page);
        }, [setFilters, setPageQueryParams]);
        // Get the next page of results
        var nextPage = (0, react_1.useCallback)(function () { return setPage(filters.page + 1); }, [setPage, filters.page]);
        // Get the previous page of results
        var prevPage = (0, react_1.useCallback)(function () { return setPage(filters.page - 1); }, [setPage, filters.page]);
        /* After ID Methods */
        // Set the ID of the last record retrieved
        var setAfter = (0, react_1.useCallback)(function (after) {
            if (results.length && filters.after !== after) {
                setFilters(function (params) { return (__assign(__assign({}, params), { after: after })); });
            }
            else if (!results.length) {
                setFilters(function (_a) {
                    var after = _a.after, params = __rest(_a, ["after"]);
                    return (__assign({}, params));
                });
            }
        }, [results.length, setFilters, filters.after]);
        // Get the records after the last record most recently retrieved
        var getAfter = (0, react_1.useCallback)(function () {
            if (results.length) {
                setAfter(results[results.length - 1].id);
            }
        }, [results, setAfter]);
        // Get the records before the last record most recently retrieved
        var getBefore = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
            var beforeResults;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetcher(path, __assign(__assign({}, filters), { after: (_a = results[0]) === null || _a === void 0 ? void 0 : _a.id, direction: metadata.direction === types_1.PAGINATION_DIRECTION.ASC
                                ? types_1.PAGINATION_DIRECTION.DESC
                                : types_1.PAGINATION_DIRECTION.ASC }))];
                    case 1:
                        beforeResults = (_b.sent()).results;
                        if (beforeResults.length) {
                            setResults(function (results) { return sortResults(__spreadArray(__spreadArray([], beforeResults, true), results, true)); });
                        }
                        return [2 /*return*/];
                }
            });
        }); }, [results, metadata.direction, filters, fetcher, path, sortResults]);
        var replaceItem = (0, react_1.useCallback)(function (replacement) {
            if (!replacement)
                return;
            var resultIndex = results.findIndex(function (mi) { return mi.id === replacement.id; });
            if (!(0, react_fast_compare_1.default)(results[resultIndex], replacement)) {
                results[resultIndex] = replacement;
                setResults(function () { return __spreadArray([], results, true); });
            }
        }, [results]);
        var removeItem = (0, react_1.useCallback)(function (removable) {
            if (!removable)
                return;
            setResults(function () { return results.filter(function (mi) { return mi.id !== removable.id; }); });
        }, [results]);
        var getById = (0, react_1.useCallback)(function (id) { return __awaiter(void 0, void 0, void 0, function () {
            var model;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getModelById(id)];
                    case 1:
                        model = _a.sent();
                        replaceItem(model);
                        return [2 /*return*/, model];
                }
            });
        }); }, [getModelById, replaceItem]);
        var resetResults = (0, react_1.useCallback)(function () {
            setResults([]);
        }, [setResults]);
        // As the filters change, set the filters state
        (0, react_use_1.useDeepCompareEffect)(function () {
            if (!isInitialized.current) {
                return;
            }
            setFilters(function (f) {
                var pageFilters = FILTER_KEYS.reduce(function (a, k) {
                    var _a;
                    return (__assign(__assign({}, a), (_a = {}, _a[k] = f[k], _a)));
                }, { page: 1 });
                resetResults();
                return __assign(__assign(__assign({}, pageFilters), { page: 1 }), props.filters);
            });
        }, [(_k = props.filters) !== null && _k !== void 0 ? _k : {}, resetResults]);
        (0, react_2.useEffect)(function () {
            if (!infiniteScroll)
                setPageQueryParams(filters.page);
        }, [filters.page, setPageQueryParams, infiniteScroll]);
        (0, react_2.useEffect)(function () {
            var _a;
            if (((_a = props.options) === null || _a === void 0 ? void 0 : _a.infiniteScroll) != undefined)
                setInfiniteScroll(props.options.infiniteScroll);
        }, [(_l = props.options) === null || _l === void 0 ? void 0 : _l.infiniteScroll, setInfiniteScroll]);
        (0, react_2.useEffect)(function () {
            var _a;
            if (((_a = props.options) === null || _a === void 0 ? void 0 : _a.scrollOffset) != undefined)
                setScrollOffset(props.options.scrollOffset);
        }, [(_m = props.options) === null || _m === void 0 ? void 0 : _m.scrollOffset, setScrollOffset]);
        // As the custom state prop changes, set the componentProps state
        (0, react_use_1.useDeepCompareEffect)(function () {
            setComponentProps(props.componentProps);
        }, [(_o = props.componentProps) !== null && _o !== void 0 ? _o : {}]);
        (0, react_use_1.useDeepCompareEffect)(function () {
            setInfiniteScrollProps(props.infiniteScrollProps);
        }, [(_p = props.infiniteScrollProps) !== null && _p !== void 0 ? _p : {}]);
        // As the results change, set the results state
        (0, react_2.useEffect)(function () {
            // If in infinite scroll mode, add the results to the array and sort
            if (infiniteScroll) {
                setResults(function (results) { return sortResults(__spreadArray(__spreadArray([], results, true), apiResults, true)); });
                // Otherwise, override the existing results
            }
            else {
                setResults(apiResults);
            }
        }, [setResults, apiResults, infiniteScroll, sortResults]);
        (0, react_use_1.useDeepCompareEffect)(function () {
            if (apiMetadata && !(apiMetadata === null || apiMetadata === void 0 ? void 0 : apiMetadata.uninitialized)) {
                setMetadata(apiMetadata);
            }
        }, [setMetadata, apiMetadata !== null && apiMetadata !== void 0 ? apiMetadata : {}, metadata !== null && metadata !== void 0 ? metadata : {}]);
        var PaginatedComponentContainer = (0, react_1.useMemo)(function () {
            return function (_a) {
                var children = _a.children;
                return infiniteScroll ? (react_1.default.createElement(PaginatedInfiniteScroll_1.default, __assign({}, infiniteScrollProps), children)) : (react_1.default.createElement(react_1.default.Fragment, null, children));
            };
        }, [infiniteScrollProps, infiniteScroll]);
        (0, react_2.useEffect)(function () {
            isInitialized.current = true;
        }, []);
        var contextValue = (0, react_1.useMemo)(function () { return ({
            filters: filters,
            setFilters: setFilters,
            metadata: metadata,
            results: results,
            setPage: setPage,
            nextPage: nextPage,
            prevPage: prevPage,
            componentProps: componentProps,
            // mutateResults,
            loading: loading,
            setAfter: setAfter,
            getAfter: getAfter,
            getBefore: getBefore,
            getById: getById,
            removeItem: removeItem,
            scrollOffset: scrollOffset,
            isPreviousData: isPreviousData,
        }); }, [
            filters,
            setFilters,
            metadata,
            results,
            setPage,
            nextPage,
            prevPage,
            componentProps,
            // mutateResults,
            loading,
            setAfter,
            getAfter,
            getBefore,
            getById,
            removeItem,
            scrollOffset,
            isPreviousData,
        ]);
        return (react_1.default.createElement(PaginationContext.Provider, { value: contextValue },
            react_1.default.createElement(PaginatedComponentContainer, null,
                react_1.default.createElement(Component, __assign({}, props, { path: path })))));
    };
};
exports.withPagination = withPagination;
exports.default = exports.withPagination;
//# sourceMappingURL=withPagination.js.map